"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.userConfigs = exports.TwoFaTypes = void 0;
var TwoFaTypes = exports.TwoFaTypes = {
  Yubico: 'Yubico',
  Google: 'Google'
};
var userConfigs = exports.userConfigs = {
  TwoFaType: '2FAType'
};